/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FeatureAccessDeniedEventsResponse,
  GrantBundleRequest,
  GrantDistributorEntitlementRequest,
  GrantEntitlementRequest,
  RevertBundleSyncRequest,
  UpdateEntitlementRequest,
} from '../models/index';
import {
    FeatureAccessDeniedEventsResponseFromJSON,
    FeatureAccessDeniedEventsResponseToJSON,
    GrantBundleRequestFromJSON,
    GrantBundleRequestToJSON,
    GrantDistributorEntitlementRequestFromJSON,
    GrantDistributorEntitlementRequestToJSON,
    GrantEntitlementRequestFromJSON,
    GrantEntitlementRequestToJSON,
    RevertBundleSyncRequestFromJSON,
    RevertBundleSyncRequestToJSON,
    UpdateEntitlementRequestFromJSON,
    UpdateEntitlementRequestToJSON,
} from '../models/index';

export interface GetCommercialProfileRequest {
    tenantId: string;
}

export interface GetFeatureAccessDeniedEventsRequest {
    tenantId?: string;
    page?: number;
    pageSize?: number;
}

export interface GrantBundleOperationRequest {
    grantBundleRequest: GrantBundleRequest;
}

export interface GrantDistributorEntitlementOperationRequest {
    grantDistributorEntitlementRequest: GrantDistributorEntitlementRequest;
}

export interface GrantEntitlementOperationRequest {
    grantEntitlementRequest: GrantEntitlementRequest;
}

export interface ListBundleGrantsRequest {
    tenantId?: string;
    bundleId?: string;
}

export interface ListEntitlementsRequest {
    tenantId?: string;
    includeInactiveEntitlements?: boolean;
}

export interface RevertBundleSyncOperationRequest {
    revertBundleSyncRequest: RevertBundleSyncRequest;
}

export interface RevokeBundleGrantRequest {
    tenantBundleGrantId: string;
}

export interface RevokeEntitlementRequest {
    tenantId: string;
    featureId: string;
}

export interface UpdateEntitlementOperationRequest {
    tenantId: string;
    featureId: string;
    updateEntitlementRequest: UpdateEntitlementRequest;
}

/**
 * EntitlementAdminApi - interface
 * 
 * @export
 * @interface EntitlementAdminApiInterface
 */
export interface EntitlementAdminApiInterface {
    /**
     * Returns a short summary of commercial flags for a tenant, including whether entitlement_distributor (MSP / grantor) is active. Requires that the session may access the given tenantId.
     * @summary Tenant commercial profile (admin)
     * @param {string} tenantId Tenant id to inspect
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementAdminApiInterface
     */
    getCommercialProfileRaw(requestParameters: GetCommercialProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns a short summary of commercial flags for a tenant, including whether entitlement_distributor (MSP / grantor) is active. Requires that the session may access the given tenantId.
     * Tenant commercial profile (admin)
     */
    getCommercialProfile(requestParameters: GetCommercialProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns FEATURE_ACCESS_DENIED audit events for selected tenants (or all effective tenants when no tenantId). Optional tenantId filters to one tenant. Pagination: page is 1-based; total is the total count across all pages.
     * @summary List feature access denied events (admin)
     * @param {string} [tenantId] Optional tenant ID to filter events to a single tenant
     * @param {number} [page] Page number (1-based)
     * @param {number} [pageSize] Page size (max 100)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementAdminApiInterface
     */
    getFeatureAccessDeniedEventsRaw(requestParameters: GetFeatureAccessDeniedEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FeatureAccessDeniedEventsResponse>>;

    /**
     * Returns FEATURE_ACCESS_DENIED audit events for selected tenants (or all effective tenants when no tenantId). Optional tenantId filters to one tenant. Pagination: page is 1-based; total is the total count across all pages.
     * List feature access denied events (admin)
     */
    getFeatureAccessDeniedEvents(requestParameters: GetFeatureAccessDeniedEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FeatureAccessDeniedEventsResponse>;

    /**
     * Returns allowed source options for grant UI.
     * @summary Get entitlement options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementAdminApiInterface
     */
    getOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns allowed source options for grant UI.
     * Get entitlement options
     */
    getOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Creates one bundle grant record and entitlements only for features the tenant does not already have. Existing entitlements are preserved.
     * @summary Grant a bundle to a tenant
     * @param {GrantBundleRequest} grantBundleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementAdminApiInterface
     */
    grantBundleRaw(requestParameters: GrantBundleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Creates one bundle grant record and entitlements only for features the tenant does not already have. Existing entitlements are preserved.
     * Grant a bundle to a tenant
     */
    grantBundle(requestParameters: GrantBundleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Single dedicated surface (Phase D) for issuing MSP / grantor capability. Requires system admin tenant as current context. Equivalent to POST with featureId entitlement_distributor; optional `reason` is included in the GRANT_DISTRIBUTOR audit business context.
     * @summary Grant entitlement_distributor (platform only)
     * @param {GrantDistributorEntitlementRequest} grantDistributorEntitlementRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementAdminApiInterface
     */
    grantDistributorEntitlementRaw(requestParameters: GrantDistributorEntitlementOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Single dedicated surface (Phase D) for issuing MSP / grantor capability. Requires system admin tenant as current context. Equivalent to POST with featureId entitlement_distributor; optional `reason` is included in the GRANT_DISTRIBUTOR audit business context.
     * Grant entitlement_distributor (platform only)
     */
    grantDistributorEntitlement(requestParameters: GrantDistributorEntitlementOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Grant entitlement (admin)
     * @param {GrantEntitlementRequest} grantEntitlementRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementAdminApiInterface
     */
    grantEntitlementRaw(requestParameters: GrantEntitlementOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Grant entitlement (admin)
     */
    grantEntitlement(requestParameters: GrantEntitlementOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns bundle grants with catalog drift and revision metadata. When tenantId is set, returns grants for that tenant only. When tenantId is omitted, returns grants for all effective (selected) tenants, same scope as GET /admin/entitlements without tenantId. Optional bundleId filter.
     * @summary List bundle grants (admin)
     * @param {string} [tenantId] Optional tenant ID; omit to list grants for all effective tenants
     * @param {string} [bundleId] Optional bundle ID filter (e.g. MXDR)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementAdminApiInterface
     */
    listBundleGrantsRaw(requestParameters: ListBundleGrantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns bundle grants with catalog drift and revision metadata. When tenantId is set, returns grants for that tenant only. When tenantId is omitted, returns grants for all effective (selected) tenants, same scope as GET /admin/entitlements without tenantId. Optional bundleId filter.
     * List bundle grants (admin)
     */
    listBundleGrants(requestParameters: ListBundleGrantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns entitlements for the specified tenant or for all effective (selected) tenants when tenantId is omitted. By default only currently effective entitlements are returned. Set includeInactiveEntitlements=true to include expired or not-yet-effective rows. At most one row per (tenant, feature); re-granting updates the same row.
     * @summary List entitlements (admin)
     * @param {string} [tenantId] Optional tenant ID; when omitted, returns entitlements for all effective (selected) tenants
     * @param {boolean} [includeInactiveEntitlements] When false (default), omit entitlements that are expired or not yet effective
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementAdminApiInterface
     */
    listEntitlementsRaw(requestParameters: ListEntitlementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns entitlements for the specified tenant or for all effective (selected) tenants when tenantId is omitted. By default only currently effective entitlements are returned. Set includeInactiveEntitlements=true to include expired or not-yet-effective rows. At most one row per (tenant, feature); re-granting updates the same row.
     * List entitlements (admin)
     */
    listEntitlements(requestParameters: ListEntitlementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Phase E (ADR 0004): returns active bundles in the current grantor tenant\'s scope — platform catalog (no provider) plus rows where provider_tenant_id equals the session\'s current grantor. Same filter as grant-bundle.
     * @summary List bundles grantable in current context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementAdminApiInterface
     */
    listGrantableBundlesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Phase E (ADR 0004): returns active bundles in the current grantor tenant\'s scope — platform catalog (no provider) plus rows where provider_tenant_id equals the session\'s current grantor. Same filter as grant-bundle.
     * List bundles grantable in current context
     */
    listGrantableBundles(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Revert a single history row (historyId) or all changes in a batch (batchId). Only one of historyId or batchId must be set.
     * @summary Revert bundle sync change(s)
     * @param {RevertBundleSyncRequest} revertBundleSyncRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementAdminApiInterface
     */
    revertBundleSyncRaw(requestParameters: RevertBundleSyncOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Revert a single history row (historyId) or all changes in a batch (batchId). Only one of historyId or batchId must be set.
     * Revert bundle sync change(s)
     */
    revertBundleSync(requestParameters: RevertBundleSyncOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Removes all entitlements that were created from this grant. Does not remove features the tenant had from another source. Sets revoked_at on the grant record.
     * @summary Revoke a bundle grant
     * @param {string} tenantBundleGrantId Tenant bundle grant ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementAdminApiInterface
     */
    revokeBundleGrantRaw(requestParameters: RevokeBundleGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Removes all entitlements that were created from this grant. Does not remove features the tenant had from another source. Sets revoked_at on the grant record.
     * Revoke a bundle grant
     */
    revokeBundleGrant(requestParameters: RevokeBundleGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Revoke entitlement (admin)
     * @param {string} tenantId Tenant ID
     * @param {string} featureId Feature ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementAdminApiInterface
     */
    revokeEntitlementRaw(requestParameters: RevokeEntitlementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Revoke entitlement (admin)
     */
    revokeEntitlement(requestParameters: RevokeEntitlementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Update entitlement (admin)
     * @param {string} tenantId Tenant ID
     * @param {string} featureId Feature ID
     * @param {UpdateEntitlementRequest} updateEntitlementRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementAdminApiInterface
     */
    updateEntitlementRaw(requestParameters: UpdateEntitlementOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Update entitlement (admin)
     */
    updateEntitlement(requestParameters: UpdateEntitlementOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class EntitlementAdminApi extends runtime.BaseAPI implements EntitlementAdminApiInterface {

    /**
     * Returns a short summary of commercial flags for a tenant, including whether entitlement_distributor (MSP / grantor) is active. Requires that the session may access the given tenantId.
     * Tenant commercial profile (admin)
     */
    async getCommercialProfileRaw(requestParameters: GetCommercialProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getCommercialProfile().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tenantId'] != null) {
            queryParameters['tenantId'] = requestParameters['tenantId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/admin/entitlements/commercial-profile`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns a short summary of commercial flags for a tenant, including whether entitlement_distributor (MSP / grantor) is active. Requires that the session may access the given tenantId.
     * Tenant commercial profile (admin)
     */
    async getCommercialProfile(requestParameters: GetCommercialProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getCommercialProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns FEATURE_ACCESS_DENIED audit events for selected tenants (or all effective tenants when no tenantId). Optional tenantId filters to one tenant. Pagination: page is 1-based; total is the total count across all pages.
     * List feature access denied events (admin)
     */
    async getFeatureAccessDeniedEventsRaw(requestParameters: GetFeatureAccessDeniedEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FeatureAccessDeniedEventsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['tenantId'] != null) {
            queryParameters['tenantId'] = requestParameters['tenantId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/admin/entitlements/feature-access-denied-events`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FeatureAccessDeniedEventsResponseFromJSON(jsonValue));
    }

    /**
     * Returns FEATURE_ACCESS_DENIED audit events for selected tenants (or all effective tenants when no tenantId). Optional tenantId filters to one tenant. Pagination: page is 1-based; total is the total count across all pages.
     * List feature access denied events (admin)
     */
    async getFeatureAccessDeniedEvents(requestParameters: GetFeatureAccessDeniedEventsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FeatureAccessDeniedEventsResponse> {
        const response = await this.getFeatureAccessDeniedEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns allowed source options for grant UI.
     * Get entitlement options
     */
    async getOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/admin/entitlements/options`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns allowed source options for grant UI.
     * Get entitlement options
     */
    async getOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getOptionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates one bundle grant record and entitlements only for features the tenant does not already have. Existing entitlements are preserved.
     * Grant a bundle to a tenant
     */
    async grantBundleRaw(requestParameters: GrantBundleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['grantBundleRequest'] == null) {
            throw new runtime.RequiredError(
                'grantBundleRequest',
                'Required parameter "grantBundleRequest" was null or undefined when calling grantBundle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/admin/entitlements/grant-bundle`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GrantBundleRequestToJSON(requestParameters['grantBundleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Creates one bundle grant record and entitlements only for features the tenant does not already have. Existing entitlements are preserved.
     * Grant a bundle to a tenant
     */
    async grantBundle(requestParameters: GrantBundleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.grantBundleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Single dedicated surface (Phase D) for issuing MSP / grantor capability. Requires system admin tenant as current context. Equivalent to POST with featureId entitlement_distributor; optional `reason` is included in the GRANT_DISTRIBUTOR audit business context.
     * Grant entitlement_distributor (platform only)
     */
    async grantDistributorEntitlementRaw(requestParameters: GrantDistributorEntitlementOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['grantDistributorEntitlementRequest'] == null) {
            throw new runtime.RequiredError(
                'grantDistributorEntitlementRequest',
                'Required parameter "grantDistributorEntitlementRequest" was null or undefined when calling grantDistributorEntitlement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/admin/entitlements/distributor`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GrantDistributorEntitlementRequestToJSON(requestParameters['grantDistributorEntitlementRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Single dedicated surface (Phase D) for issuing MSP / grantor capability. Requires system admin tenant as current context. Equivalent to POST with featureId entitlement_distributor; optional `reason` is included in the GRANT_DISTRIBUTOR audit business context.
     * Grant entitlement_distributor (platform only)
     */
    async grantDistributorEntitlement(requestParameters: GrantDistributorEntitlementOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.grantDistributorEntitlementRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Grant entitlement (admin)
     */
    async grantEntitlementRaw(requestParameters: GrantEntitlementOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['grantEntitlementRequest'] == null) {
            throw new runtime.RequiredError(
                'grantEntitlementRequest',
                'Required parameter "grantEntitlementRequest" was null or undefined when calling grantEntitlement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/admin/entitlements`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GrantEntitlementRequestToJSON(requestParameters['grantEntitlementRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Grant entitlement (admin)
     */
    async grantEntitlement(requestParameters: GrantEntitlementOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.grantEntitlementRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns bundle grants with catalog drift and revision metadata. When tenantId is set, returns grants for that tenant only. When tenantId is omitted, returns grants for all effective (selected) tenants, same scope as GET /admin/entitlements without tenantId. Optional bundleId filter.
     * List bundle grants (admin)
     */
    async listBundleGrantsRaw(requestParameters: ListBundleGrantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['tenantId'] != null) {
            queryParameters['tenantId'] = requestParameters['tenantId'];
        }

        if (requestParameters['bundleId'] != null) {
            queryParameters['bundleId'] = requestParameters['bundleId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/admin/entitlements/bundle-grants`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns bundle grants with catalog drift and revision metadata. When tenantId is set, returns grants for that tenant only. When tenantId is omitted, returns grants for all effective (selected) tenants, same scope as GET /admin/entitlements without tenantId. Optional bundleId filter.
     * List bundle grants (admin)
     */
    async listBundleGrants(requestParameters: ListBundleGrantsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listBundleGrantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns entitlements for the specified tenant or for all effective (selected) tenants when tenantId is omitted. By default only currently effective entitlements are returned. Set includeInactiveEntitlements=true to include expired or not-yet-effective rows. At most one row per (tenant, feature); re-granting updates the same row.
     * List entitlements (admin)
     */
    async listEntitlementsRaw(requestParameters: ListEntitlementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['tenantId'] != null) {
            queryParameters['tenantId'] = requestParameters['tenantId'];
        }

        if (requestParameters['includeInactiveEntitlements'] != null) {
            queryParameters['includeInactiveEntitlements'] = requestParameters['includeInactiveEntitlements'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/admin/entitlements`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns entitlements for the specified tenant or for all effective (selected) tenants when tenantId is omitted. By default only currently effective entitlements are returned. Set includeInactiveEntitlements=true to include expired or not-yet-effective rows. At most one row per (tenant, feature); re-granting updates the same row.
     * List entitlements (admin)
     */
    async listEntitlements(requestParameters: ListEntitlementsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listEntitlementsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Phase E (ADR 0004): returns active bundles in the current grantor tenant\'s scope — platform catalog (no provider) plus rows where provider_tenant_id equals the session\'s current grantor. Same filter as grant-bundle.
     * List bundles grantable in current context
     */
    async listGrantableBundlesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/admin/entitlements/grantable-bundles`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Phase E (ADR 0004): returns active bundles in the current grantor tenant\'s scope — platform catalog (no provider) plus rows where provider_tenant_id equals the session\'s current grantor. Same filter as grant-bundle.
     * List bundles grantable in current context
     */
    async listGrantableBundles(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listGrantableBundlesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Revert a single history row (historyId) or all changes in a batch (batchId). Only one of historyId or batchId must be set.
     * Revert bundle sync change(s)
     */
    async revertBundleSyncRaw(requestParameters: RevertBundleSyncOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['revertBundleSyncRequest'] == null) {
            throw new runtime.RequiredError(
                'revertBundleSyncRequest',
                'Required parameter "revertBundleSyncRequest" was null or undefined when calling revertBundleSync().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/admin/entitlements/bundle-sync/revert`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RevertBundleSyncRequestToJSON(requestParameters['revertBundleSyncRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Revert a single history row (historyId) or all changes in a batch (batchId). Only one of historyId or batchId must be set.
     * Revert bundle sync change(s)
     */
    async revertBundleSync(requestParameters: RevertBundleSyncOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.revertBundleSyncRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes all entitlements that were created from this grant. Does not remove features the tenant had from another source. Sets revoked_at on the grant record.
     * Revoke a bundle grant
     */
    async revokeBundleGrantRaw(requestParameters: RevokeBundleGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantBundleGrantId'] == null) {
            throw new runtime.RequiredError(
                'tenantBundleGrantId',
                'Required parameter "tenantBundleGrantId" was null or undefined when calling revokeBundleGrant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/admin/entitlements/bundle-grants/{tenantBundleGrantId}`;
        urlPath = urlPath.replace(`{${"tenantBundleGrantId"}}`, encodeURIComponent(String(requestParameters['tenantBundleGrantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Removes all entitlements that were created from this grant. Does not remove features the tenant had from another source. Sets revoked_at on the grant record.
     * Revoke a bundle grant
     */
    async revokeBundleGrant(requestParameters: RevokeBundleGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.revokeBundleGrantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Revoke entitlement (admin)
     */
    async revokeEntitlementRaw(requestParameters: RevokeEntitlementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling revokeEntitlement().'
            );
        }

        if (requestParameters['featureId'] == null) {
            throw new runtime.RequiredError(
                'featureId',
                'Required parameter "featureId" was null or undefined when calling revokeEntitlement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/admin/entitlements/{tenantId}/{featureId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));
        urlPath = urlPath.replace(`{${"featureId"}}`, encodeURIComponent(String(requestParameters['featureId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Revoke entitlement (admin)
     */
    async revokeEntitlement(requestParameters: RevokeEntitlementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.revokeEntitlementRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update entitlement (admin)
     */
    async updateEntitlementRaw(requestParameters: UpdateEntitlementOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateEntitlement().'
            );
        }

        if (requestParameters['featureId'] == null) {
            throw new runtime.RequiredError(
                'featureId',
                'Required parameter "featureId" was null or undefined when calling updateEntitlement().'
            );
        }

        if (requestParameters['updateEntitlementRequest'] == null) {
            throw new runtime.RequiredError(
                'updateEntitlementRequest',
                'Required parameter "updateEntitlementRequest" was null or undefined when calling updateEntitlement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/admin/entitlements/{tenantId}/{featureId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));
        urlPath = urlPath.replace(`{${"featureId"}}`, encodeURIComponent(String(requestParameters['featureId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateEntitlementRequestToJSON(requestParameters['updateEntitlementRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Update entitlement (admin)
     */
    async updateEntitlement(requestParameters: UpdateEntitlementOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.updateEntitlementRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
